import { Component, OnInit } from "@angular/core";
import { BaseComponent, UserService, ProductService, WindowService, environment, HelperService } from "@mypxplat/xplat/core";
import { take } from "rxjs/operators";
import { AppService, AvoService, WebErrorHandler } from "@mypxplat/xplat/web/core";
import { UpdatePaymentSourceStripeComponent, CancelSubscriptionStripeComponent, SphereSubscribeStripeComponent } from "../../../modals";
import { ProductDetail } from "@mypxplat/xplat/core";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { CurrencyPipe } from "@angular/common";

declare var Stripe;

@Component({
  selector: "myp-account-plan-stripe",
  templateUrl: "./plan-stripe.component.html",
})
export class PlanStripeComponent extends BaseComponent implements OnInit {
  public statusMap = {
    active: { title: "Active", color: "green" },
    canceled: { title: "Canceled", color: "red" },
    unpaid: { title: "UnPaid", color: "orange" },
    past_due: { title: "Past Due", color: "orange" },
    incomplete: { title: "Incomplete", color: "orange" },
    incomplete_expired: { title: "Incomplete And Expired", color: "red" },
    trialing: { title: "Trailing", color: "orange" },
    ended: { title: "Expired", color: "gray" },
    "missed payment": { title: "Missed Payment", color: "orange" },
  };

  public subscriptionProduct: ProductDetail;
  public defaultCard: any;
  public loading: boolean = true;
  public noSubscriptionFound: boolean = false;
  public nextChargeDate: any;
  public editingExpDetails: any = false;
  public expDetails: any = {};
  public proratedTotal: any;
  public formatedProratedTotal: any;
  public prorationDate: any;
  public clientSecret: string;
  public subscriptionId: string;
  public stripe: any;
  public priceList: any;
  public isConverted: boolean = false;
  public convertedAmount: any;
  public isTaxIncluded: boolean = false;
  public monthDifference: number;

  public isNoDecimalCurrency(currency) {
    if (currency) {
      return environment.stripe.no_decimal_currencies.includes(currency.toUpperCase());
    }
    return false;
  }

  public isDivisibleBy100(currency) {
    if (currency) {
      return environment.stripe.divisible_by_100_currencies.includes(currency.toUpperCase());
    }
    return false;
  }
  constructor(
    public userService: UserService,
    public appService: AppService,
    public spinner: NgxSpinnerService,
    public productService: ProductService,
    private _win: WindowService,
    public translate: TranslateService,
    private currencyPipe: CurrencyPipe,
    public avoService: AvoService,
    public helperService: HelperService,
    public errorService: WebErrorHandler
  ) {
    super(userService);
  }

  ngOnInit() {
    this.init();
    this.userService.getStorageDetails().subscribe();
    this.stripe = Stripe(environment.stripe.public_key);
  }

  init(callBack?, force?) {
    this.userService.subscriptionDetails(force).subscribe({
      next: (result: any) => {
        this.loading = false;
        if (this.userService.userSubscription.base.stripe_subscription.default_payment_object) {
          this.defaultCard = this.userService.userSubscription.base.stripe_subscription.default_payment_object;
        }
        if (this.userService.userSubscription) {
          if (this.userService.userSubscription.base) {
            this.nextChargeDate = this.userService.userSubscription.base.stripe_subscription.nextChargeDate;
            this.monthDifference = monthDiff(new Date(this.nextChargeDate), new Date());
            this.isTaxIncluded = this.userService.userSubscription.base.stripe_subscription.metadata.IsTaxInclusive == "true" ? true : false;
          }
          if (callBack) callBack();
          this.productService.getSubscriptionDetails(this.userService.userSubscription.base.Asset_id).subscribe((result: ProductDetail) => {
            this.subscriptionProduct = result;
          });
        }
      },
      error: (error) => {
        this.loading = false;
        this.noSubscriptionFound = true;
      },
    });
  }

  cancelSubscription() {
    const modalRef = this.appService.showModal(CancelSubscriptionStripeComponent, { size: "lg" });
    modalRef.componentInstance.canceled.pipe(take(1)).subscribe((result) => {
      this.avoService.trackEvent().orderCanceled({
        userId_: this.userService.userSubscription.base.Customer_id,
        prsId: this.userService.userSubscription.base.Customer_id,
        prsSubStatus: this.userService.userSubscription.base.status,
        subProvider: this.userService.userSubscription.base.provider,
        subStartDate: this.userService.userSubscription.base.start_date,
        subEndDate: this.userService.userSubscription.base.end_date,
        subType: this.userService.userSubscription.base.type,
        subCancelReason: result.subCancelReason,
        subCancelDetails: result.subCancelDetails,
      });
      this.spinner.show();
      this.init(() => {
        this.spinner.hide();
      }, true);
    });
  }

  upgrade() {
    const modalRef = this.appService.showModal(SphereSubscribeStripeComponent, {
      size: "xl",
      backdrop: "static",
    });
    modalRef.componentInstance.isModal = true;
  }

  previewSwitchPlanPrice() {
    this.spinner.show();
    if (this.priceList) {
      if (this.userService.userSubscription?.base?.stripe_subscription?.product) {
        let switchPrice = this.priceList.filter(
          (p) =>
            p.currency === this.userService.userSubscription.base.stripe_subscription.product.price.currency &&
            p.recurring.interval === (this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year" ? "month" : "year")
        );
        if (switchPrice && switchPrice.length) {
          this.isConverted = false;
          this.userService.previewStripeInvoice({ price_id: switchPrice[0].id, is_tax_inclusive: this.isTaxIncluded }).subscribe({
            next: (result: any) => {
              if (result && result.data) {
                this.proratedTotal = this.isNoDecimalCurrency(result.data.currency)
                  ? this.isDivisibleBy100(result.data.currency)
                    ? Number((result.data.total / 100).toFixed(0))
                    : result.data.total
                  : Number((result.data.total / 100).toFixed(2));
                this.formatedProratedTotal = this.currencyPipe.transform(this.proratedTotal, result.data.currency.toUpperCase());
                this.prorationDate = result.data.subscription_proration_date;
                this.switchPlan(switchPrice[0].id);
              }
            },
            error: (error: any) => {
              this.spinner.hide();
              alert("There was an error switching your subscription plan, please try again.");
            },
          });
        } else {
          this.isConverted = true;
          let basePrices = this.priceList.filter(
            (p) => p.currency === "usd" && p.recurring.interval === (this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year" ? "month" : "year")
          );

          let currencyData = {
            currency_code: this.userService.userSubscription.base.stripe_subscription.product.price.currency,
            convert: [],
          };
          if (basePrices && basePrices.length) {
            basePrices.map((price) => {
              currencyData.convert.push({
                from: "usd",
                value: (price.unit_amount / 100).toFixed(2),
                interval: price.recurring.interval,
              });
            });

            this.userService.currencyConvert(currencyData).subscribe((result: any) => {
              if (result.success && result.data.every((c) => c.valid === true)) {
                result.data.map((price) => {
                  this.convertedAmount = this.isNoDecimalCurrency(price["to-type"]) ? parseInt(price["result-float"]) : Number(price["result-float"].toFixed(2));

                  this.userService
                    .previewStripeInvoice({
                      price_data: {
                        recurring: {
                          interval: this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year" ? "month" : "year",
                        },
                        product:
                          this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year"
                            ? environment.stripe.subscription_product.monthly
                            : environment.stripe.subscription_product.annual, //inverse product as it checks on current interval and not updated interval
                        currency: this.userService.userSubscription.base.stripe_subscription.product.price.currency,
                        unit_amount:
                          this.isNoDecimalCurrency(this.userService.userSubscription.base.stripe_subscription.product.price.currency) &&
                          !this.isDivisibleBy100(this.userService.userSubscription.base.stripe_subscription.product.price.currency)
                            ? this.convertedAmount
                            : parseInt((this.convertedAmount * 100).toFixed(0)),
                        tax_behavior: "unspecified",
                      },
                      is_tax_inclusive: this.isTaxIncluded,
                    })
                    .subscribe({
                      next: (result: any) => {
                        if (result && result.data) {
                          this.proratedTotal = this.isNoDecimalCurrency(result.data.currency)
                            ? this.isDivisibleBy100(result.data.currency)
                              ? Number((result.data.total / 100).toFixed(0))
                              : result.data.total
                            : Number((result.data.total / 100).toFixed(2));
                          this.formatedProratedTotal = this.currencyPipe.transform(this.proratedTotal, result.data.currency.toUpperCase());
                          this.prorationDate = result.data.subscription_proration_date;
                          this.switchPlan();
                        }
                      },
                      error: (error: any) => {
                        this.spinner.hide();
                        alert("There was an error switching your subscription plan, please try again.");
                      },
                    });
                });
              }
            });
          }
        }
      } else {
        alert("An error occurred while switching your subscription plan, please refresh your browser and try again.");
      }
    } else {
      this.userService.getSpherePricesStripe().subscribe((result: any) => {
        if (result.success && result.data) {
          if (result.data.prices) {
            if (this.userService.userSubscription?.base?.stripe_subscription?.product) {
              this.priceList = result.data.prices.filter((p) => p.product === environment.stripe.subscription_product.monthly || p.product === environment.stripe.subscription_product.annual);
              let switchPrice = this.priceList.filter(
                (p) =>
                  p.currency === this.userService.userSubscription.base.stripe_subscription.product.price.currency &&
                  p.recurring.interval === (this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year" ? "month" : "year")
              );
              if (switchPrice && switchPrice.length) {
                this.isConverted = false;
                this.userService.previewStripeInvoice({ price_id: switchPrice[0].id, is_tax_inclusive: this.isTaxIncluded }).subscribe({
                  next: (result: any) => {
                    if (result && result.data) {
                      this.proratedTotal = this.isNoDecimalCurrency(result.data.currency)
                        ? this.isDivisibleBy100(result.data.currency)
                          ? Number((result.data.total / 100).toFixed(0))
                          : result.data.total
                        : Number((result.data.total / 100).toFixed(2));
                      this.formatedProratedTotal = this.currencyPipe.transform(this.proratedTotal, result.data.currency.toUpperCase());
                      this.prorationDate = result.data.subscription_proration_date;
                      this.switchPlan(switchPrice[0].id);
                    }
                  },
                  error: (error: any) => {
                    this.spinner.hide();
                    alert("There was an error switching your subscription plan, please try again.");
                  },
                });
              } else {
                this.isConverted = true;
                let basePrices = this.priceList.filter(
                  (p) => p.currency === "usd" && p.recurring.interval === (this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year" ? "month" : "year")
                );

                let currencyData = {
                  currency_code: this.userService.userSubscription.base.stripe_subscription.product.price.currency,
                  convert: [],
                };
                if (basePrices && basePrices.length) {
                  basePrices.map((price) => {
                    currencyData.convert.push({
                      from: "usd",
                      value: (price.unit_amount / 100).toFixed(2),
                      interval: price.recurring.interval,
                    });
                  });

                  this.userService.currencyConvert(currencyData).subscribe((result: any) => {
                    if (result.success && result.data.every((c) => c.valid === true)) {
                      result.data.map((price) => {
                        this.convertedAmount = this.isNoDecimalCurrency(price["to-type"]) ? parseInt(price["result-float"]) : Number(price["result-float"].toFixed(2));
                        this.spinner.show();

                        this.userService
                          .previewStripeInvoice({
                            price_data: {
                              recurring: {
                                interval: this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year" ? "month" : "year",
                              },
                              product:
                                this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year"
                                  ? environment.stripe.subscription_product.monthly
                                  : environment.stripe.subscription_product.annual,
                              currency: this.userService.userSubscription.base.stripe_subscription.product.price.currency, //inverse product as it checks on current interval and not updated interval
                              unit_amount:
                                this.isNoDecimalCurrency(this.userService.userSubscription.base.stripe_subscription.product.price.currency) &&
                                !this.isDivisibleBy100(this.userService.userSubscription.base.stripe_subscription.product.price.currency)
                                  ? this.convertedAmount
                                  : parseInt((this.convertedAmount * 100).toFixed(0)),
                              tax_behavior: "unspecified",
                            },
                            is_tax_inclusive: this.isTaxIncluded,
                          })
                          .subscribe({
                            next: (result: any) => {
                              if (result && result.data) {
                                this.proratedTotal = this.isNoDecimalCurrency(result.data.currency)
                                  ? this.isDivisibleBy100(result.data.currency)
                                    ? Number((result.data.total / 100).toFixed(0))
                                    : result.data.total
                                  : Number((result.data.total / 100).toFixed(2));
                                this.formatedProratedTotal = this.currencyPipe.transform(this.proratedTotal, result.data.currency.toUpperCase());
                                this.prorationDate = result.data.subscription_proration_date;
                                this.switchPlan();
                              }
                            },
                            error: (error: any) => {
                              this.spinner.hide();
                              alert("There was an error switching your subscription plan, please try again.");
                            },
                          });
                      });
                    }
                  });
                }
              }
            } else {
              alert("An error occurred while switching your subscription plan, please refresh your browser and try again.");
            }
          }
        }
      });
    }
  }

  switchPlan(priceId?) {
    if (!this.userService.userSubscription?.base?.stripe_subscription?.product) {
      alert("An error occurred while switching your subscription plan, please refresh your browser and try again.");
      return false;
    }
    let subscribeRequest = this.isConverted
      ? {
          sales_channel: "myp_upgrade",
          proration_date: this.prorationDate,
          price_data: {
            recurring: {
              interval: this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year" ? "month" : "year",
            },
            product:
              this.userService.userSubscription.base.stripe_subscription.product.price.recurring["interval"] === "year"
                ? environment.stripe.subscription_product.monthly
                : environment.stripe.subscription_product.annual, //inverse product as it checks on current interval and not updated interval
            currency: this.userService.userSubscription.base.stripe_subscription.product.price.currency,
            unit_amount:
              this.isNoDecimalCurrency(this.userService.userSubscription.base.stripe_subscription.product.price.currency) &&
              !this.isDivisibleBy100(this.userService.userSubscription.base.stripe_subscription.product.price.currency)
                ? this.convertedAmount
                : parseInt((this.convertedAmount * 100).toFixed(0)),
            tax_behavior: "unspecified",
          },
          is_tax_inclusive: this.isTaxIncluded,
        }
      : {
          price_id: priceId,
          sales_channel: "myp_upgrade",
          proration_date: this.prorationDate,
          is_tax_inclusive: this.isTaxIncluded,
        };
    let msg = "Are you sure you want to switch to an annual plan? You will be charged for remaining amount of " + this.formatedProratedTotal;
    if (confirm(msg)) {
      this.userService.stripeSubscriptionSwitch(subscribeRequest).subscribe({
        next: (result: any) => {
          if (result.success && result.data) {
            if (result.data.invoice) {
              setTimeout(() => {
                this.subscriptionResume(result.data.invoice);
              }, 3000);
            } else {
              this.spinner.hide();
              alert("There was an error switching your subscription plan, please try again.");
            }
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.appService.alertError(error);
        },
      });
    } else {
      this.spinner.hide();
    }
  }

  subscriptionResume(invoiceData) {
    this.userService
      .subscriptionResume({
        invoice: invoiceData,
        transaction_type: "switch",
      })
      .subscribe({
        next: (result: any) => {
          if (result.success && result.data) {
            this.clientSecret = result.data.clientSecret;
            this.subscriptionId = result.data.subscriptionId;
            this.confirmCardPayment();
          }
        },
        error: (error) => {
          this.spinner.hide();
          this.appService.alertError(error);
        },
      });
  }

  confirmCardPayment() {
    this.stripe.confirmCardPayment(this.clientSecret).then((response) => {
      if (response.error) {
        this.spinner.hide();
        alert(response.error.message);
      } else {
        this.init(() => {
          this.spinner.hide();
        }, true);
      }
    });
  }

  deactivate(activation: any, mixer?) {
    this._win
      .confirm(this.translate.instant("sphere.account.remove_activation_confirm"))
      .then((_) => {
        let args: any = {
          activation_id: activation.id,
        };
        if (mixer) {
          args.hardwareSerial = activation.hardwareSerialNumber;
        } else {
          args.productid = activation.licenseId;
        }
        activation.loading = true;
        this.productService.deactivateSoftware(args).subscribe((result) => {
          this.productService.getSubscriptionDetails(this.userService.userSubscription.base.Asset_id).subscribe((result: ProductDetail) => {
            this.subscriptionProduct = result;
            activation.loading = false;
          });
        });
      })
      .catch((_) => {});
  }

  reactivate() {
    let reactivate = {
      subscription_id: this.userService.userSubscription.base.stripe_subscription.id,
      source: "myp_upgrade",
    };
    this.spinner.show();
    this.userService.reactivateSubscription(reactivate).subscribe((result: any) => {
      if (result.subscriptions) {
        this.init(() => {
          this.spinner.hide();
        }, true);
      }
    });
  }

  showUpdateCard() {
    const modalRef = this.appService.showModal(UpdatePaymentSourceStripeComponent, { size: "lg" });
    modalRef.componentInstance.userCountry = this.userService.userSubscription.base.stripe_subscription.metadata.Address_Country;
    modalRef.componentInstance.isTaxInclusive = this.userService.userSubscription.base.stripe_subscription.metadata.IsTaxInclusive == "true" ? true : false;
    modalRef.componentInstance.cardAdded.pipe(take(1)).subscribe((result) => {
      this.init(false, true);
    });
  }
}

function monthDiff(startingDate, endingDate) {
  let startDate = new Date(new Date(startingDate).toISOString().substr(0, 10));
  if (!endingDate) {
    endingDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
  }
  let endDate = new Date(endingDate);
  if (startDate > endDate) {
    const swap = startDate;
    startDate = endDate;
    endDate = swap;
  }
  const startYear = startDate.getFullYear();
  const february = (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0 ? 29 : 28;
  const daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  let monthDiff = endDate.getMonth() - startDate.getMonth();
  if (monthDiff < 0) {
    monthDiff += 12;
  }
  let dayDiff = endDate.getDate() - startDate.getDate();
  if (dayDiff < 0) {
    if (monthDiff > 0) {
      monthDiff--;
    } else {
      monthDiff = 11;
    }
    dayDiff += daysInMonth[startDate.getMonth()];
  }

  return monthDiff;
}
